export const queryKeys = {
  booking: {
    list: (payload: string) => ['booking-list', payload] as const,
    usersList: (payload: string) => ['booking-users-list', payload] as const,
    details: (id: string | number) => ['booking-details', id] as const
  },
  roster: {
    daily: (payload: string) => ['lesson-schedule', payload] as const,
    entries: (payload: string) => ['lesson-entries', payload] as const,
    participants: (scheduleLessonId: number | null, query: string) =>
      ['participants-list', scheduleLessonId, query] as const,
    instructorRoster: (id: string | number | null, queryStr: string) =>
      ['instructor-roster-list', { id, queryStr }] as const
  },
  instructor: {
    list: (payload: string) => ['instructor-list', payload] as const,
    details: (id: number) => ['instructor-details', id] as const,
    commission: (payload: string) => ['instructor-commission', payload] as const
  }
};
